import styled from 'styled-components';

export const LabelContainer = styled.div`
  margin-left: 0.125rem;
`;

export const GreenLabel = styled.span`
  background-color: #dbe9db;
  margin: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.25rem;
  [data-theme='dark'] & {
    background-color: rgba(8, 236, 184, 0.12);
    color: #08ecb8;
  }
`;

export const YellowLabel = styled.span`
  background-color: #faf1d1;
  margin: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.25rem;
  [data-theme='dark'] & {
    background-color: rgba(210, 226, 64, 0.12);
    color: #c8d63a;
  }
`;

export const RedLabel = styled.span`
  background-color: #ffbeae;
  margin: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.25rem;
  [data-theme='dark'] & {
    background-color: rgba(250, 89, 104, 0.12);
    color: #fa5968;
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 0.25rem;
`;

export const SwitchWrapper = styled.div`
  margin-left: 0.5rem;
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
`;
